import React from 'react';
import UnderConstructionScreen from './UnderConstructionScreen';

const TutorialsScreen = () => (
    <UnderConstructionScreen
        eyebrow="Tutorials"
        icon="play-circle-outline"
        title="Learn how to get the most out of SnapCamp."
        subtitle="We are creating a library of video walkthroughs, step-by-step guides, and quick tips to help both families and hosts navigate every part of the platform with confidence."
        accentColor="#F59E0B"
        features={[
            {
                icon: 'video-outline',
                title: 'Video walkthroughs',
                description: 'Short screen recordings and guided tours covering every key workflow — from signing up to booking your first camp session.',
            },
            {
                icon: 'text-box-check-outline',
                title: 'Step-by-step guides',
                description: 'Written tutorials with screenshots for families discovering camps and hosts setting up and managing their listings.',
            },
            {
                icon: 'frequently-asked-questions',
                title: 'FAQ and quick tips',
                description: 'Answers to the most common questions from both families and hosts, updated as the platform grows.',
            },
        ]}
        contactPrompt="Have a tutorial request?"
        contactEmail="hello@snapcamp.ai"
    />
);

export default TutorialsScreen;
